/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Use_ThisInputs */

const en_us2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this one`)
};

const pt_br2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar este`)
};

const es_419_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar este`)
};

const pt_pt2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar este`)
};

const fr_fr2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre celui-ci`)
};

const de_de2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese nehmen`)
};

const it_it2_swap_use_this = /** @type {(inputs: Swap_Use_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa questo`)
};

/**
* | output |
* | --- |
* | "Use this one" |
*
* @param {Swap_Use_ThisInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_use_this = /** @type {((inputs?: Swap_Use_ThisInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Use_ThisInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_use_this(inputs)
	if (locale === "es-419") return es_419_swap_use_this(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_use_this(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_use_this(inputs)
	if (locale === "de-DE") return de_de2_swap_use_this(inputs)
	if (locale === "it-IT") return it_it2_swap_use_this(inputs)
	return en_us2_swap_use_this(inputs)
});
export { swap_use_this as "swap.use_this" }